(() => {
  if (window.__obpWarrantyFormEnhanced) return;
  window.__obpWarrantyFormEnhanced = true;

  const rules = {
    first_name: { required: true, label: 'Ihr Name' },
    email: { required: true, type: 'email', label: 'E-Mail-Adresse' },
    phone: { type: 'tel', label: 'Telefonnummer' },
    kaufdatum: { required: true, label: 'Kaufdatum' },
    custom_65d23fc607fd9: { required: true, label: 'IMEI-Nummer' },
    message: { required: true, label: 'Fehlerbeschreibung' }
  };

  const enhanceForm = () => {
    const forms = document.querySelectorAll('.nf-form');
    if (!forms.length) return false;

    forms.forEach((form, index) => {
      if (index > 0) {
        form.closest('.nf-form-container, .nf-form-wrap, .nf-form-cont')?.remove();
        if (form.isConnected) form.remove();
        return;
      }

      const formHeading = form.querySelector('h1, h2, h3, h4');
      if (formHeading && formHeading.textContent.trim() === 'Garantieantrag') {
        formHeading.textContent = 'Angaben zu Ihrem Gerät';
      }
      const intro = [...form.querySelectorAll('p')].find((paragraph) =>
        paragraph.textContent.includes('Option einen Garantieantrag')
      );
      if (intro) {
        intro.textContent = 'Bitte füllen Sie die Pflichtfelder aus und beschreiben Sie den Fehler möglichst genau. Unser Serviceteam prüft Ihre Anfrage persönlich und meldet sich bei Ihnen.';
      }

      Object.entries(rules).forEach(([name, rule]) => {
        const field = form.elements.namedItem(name);
        if (!field) return;
        if (rule.type) field.type = rule.type;
        if (rule.required) {
          field.required = true;
          field.setAttribute('aria-required', 'true');
        }
        if (rule.label && field.placeholder && !field.placeholder.endsWith(' *') && rule.required) {
          field.placeholder = `${rule.label} *`;
        }
        const label = (field.id ? form.querySelector(`label[for="${field.id}"]`) : null)
          || field.closest('.nf-form-group')?.querySelector('label')
          || field.parentElement?.parentElement?.querySelector('label');
        if (label && rule.required && !label.textContent.trim().endsWith('*')) {
          label.textContent = `${label.textContent.trim()} *`;
        }
      });

      form.setAttribute('data-obp-warranty-form', 'enhanced');
    });

    return true;
  };

  if (enhanceForm()) return;

  const observer = new MutationObserver(() => {
    if (enhanceForm()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
